import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first } from 'rxjs';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-mi-survey',
  templateUrl: './mi-survey.component.html',
  styleUrls: ['./mi-survey.component.scss']
})
export class MiSurveyComponent implements OnInit {
  @ViewChild('miSurvey', { static: true })
  public miSurvey: Table;

  public userID: any;
  miSurveyData: any[];
  public filteredData: any = [];
  public selectedApplications: any = [];

  ipAddress: any = '000.000.000';

  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  

  selectedStatus: any;
  items: any[];
  remarks: String;
  date: any;

  filteredDataForExport: any = [];
  appVerificationItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  

  constructor(
    private messageService: MessageService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService, 
    ) { }

  ngOnInit(): void {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.loadData(this.userID);
    this.getIP();

    let actionId = 28; // Do not Change, it is fixed for Farmer Application Verifications
    this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.items = data.$values;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });

      this.appVerificationItems = [
        {
          label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
            this.exportExcel(this.filteredDataForExport, `Filtered Lot Data_(${this.date})`);
          }
        },
        // {
        //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
        //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
        //   }
        // },
      ];
  }
  

  loadData(userID){
    this.loader.start();
    this.deptDashBoardService.getApplicationsForMISubsidyLot(userID)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            // console.log("dataaa", data)
            if(data?.length == 0){
              this.miSurveyData = [];
            }
            else if (data?.length > 0) {
              this.miSurveyData = data;
            }
          },
          error: (err) => {
            this.loader.close();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
  }

  // onFilter(event){
  //   this.filteredData = [];
  //   this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;
    
  //   this.totalSelectedApp = event.filteredValue.length;
  //   event.filteredValue.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   event.filteredValue.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.AppID, 
  //         programID: val.ProgID,
  //         subsidy_Amt: val.SubsidyToFarmer_Amount,  
  //         amt_Disbus_to_Vendor: val.SubsidyToVendor_Amount, 
  //         amt_Refund_to_Farmer: val.FarmerRefund_Amount, 
  //         state_share_amt: val.StateShare_Amount, 
  //         centre_share_amt: val.CenterShare_Amount, 
  //     }) 
  //   })
  // }

  onSubmit(){
    // console.log("filtered dataaaa", this.filteredData);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
  
  handleClick(){
    let newFilteredData = this.filteredData.map(row => ({
      ...row,
      status: this.selectedStatus.flag,
      remarks: this.remarks ? this.remarks : 'undefined',
    }))

    let reqBody = {
      listLotData: newFilteredData,
      userID: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
    }
    // console.log("reqBody", reqBody)
    
    this.insertMISubsidyLot(reqBody);
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    this.loader.start();
    this.deptDashBoardService.insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
          this.loadData(this.userID);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'AutoId', header: 'Auto Id'},
      {field: 'AppID', header: 'Application ID'},
      {field: 'FarmerName', header: 'Farmer Name'},
      {field: 'VendorName', header: 'Vendor Name'},
      { field: 'SubsidyToFarmer_Amount', header: 'Subsidy To Farmer Amount' },
      { field: 'SubsidyToVendor_Amount', header: 'Subsidy To Vendor Amount' },
      { field: 'StateShare_Amount', header: 'State Share Amount' },
      { field: 'CenterShare_Amount', header: 'Center Share Amount' },
      { field: 'MaxSubsidy_Amount', header: 'Max Subsidy Amount' },
      { field: 'FarmerRefund_Amount', header: 'Farmer Refund Amount' },
      { field: 'ProgID', header: 'Programme ID' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'Scheme', header: 'Scheme' },
      { field: 'Village', header: 'Village' },
      { field: 'Block', header: 'Block' },
      { field: 'District', header: 'District' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Auto Id": d.AutoId,
          "Application ID": d.AppID,
          "Farmer Name": d.FarmerName,
          "Vendor Name": d.VendorName,
          "Subsidy To Farmer Amount": d.SubsidyToFarmer_Amount,
          "Subsidy To Vendor Amount": d.SubsidyToVendor_Amount,
          "State Share Amount": d.StateShare_Amount,
          "Center Share Amount": d.CenterShare_Amount,
          "MaxSubsidy Amount": d.MaxSubsidy_Amount,
          "Farmer Refund Amount": d.FarmerRefund_Amount,
          "Programme ID": d.ProgID,
          "Programme Name": d.ProgrammeName,
          "Scheme": d.Scheme,
          "Village": d.Village,
          "Block": d.Block,
          "District": d.District,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onRowSelect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Selected',
      detail: event.data.name,
    });
  }

  onRowUnselect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Unselected',
      detail: event.data.name,
    });
  }

  calculation(){
    this.filteredData = [];
    // this.filteredDataForExport = event.filteredValue;
    this.totalSelectedApp = 0;
    this.totalSubToFarmer = 0;
    this.totalSubToVendor = 0;
    this.totalFarmerRefund = 0;
    
    this.totalSelectedApp = this.filteredDataForExport.length;
    this.filteredDataForExport.forEach((val) => {
      this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
      this.totalSubToVendor += val.SubsidyToVendor_Amount;
      this.totalFarmerRefund += val.FarmerRefund_Amount;
    })
    this.filteredDataForExport.forEach(val => {
      this.filteredData.push(
        {
          appID: val.AppID, 
          programID: val.ProgID,
          subsidy_Amt: val.SubsidyToFarmer_Amount,  
          amt_Disbus_to_Vendor: val.SubsidyToVendor_Amount, 
          amt_Refund_to_Farmer: val.FarmerRefund_Amount, 
          state_share_amt: val.StateShare_Amount, 
          centre_share_amt: val.CenterShare_Amount, 
      }) 
    })
  }
}
